import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/header/components/alert/alert-v1.css';
import '@/components/header/components/alert/alert-v2.css';

export default function Alert() {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { showAlert, alertCss, alertMessage } = useAppSelector(ConfigSlice.selectors.header);

  if (!showAlert) return null;

  return (
    <div
      data-css-version={cssVersion}
      className='header-alert'
      style={alertCss}
      dangerouslySetInnerHTML={{ __html: alertMessage }}
    />
  );
}
